module.exports = __webpack_public_path__ + "static/media/SoundBoard.0dee891e.jpg";